<script setup lang="ts">
import GwText from '@/components/lib/base/GwText/GwText.vue'
import GwSurface from '@/components/lib/base/GwSurface/GwSurface.vue'

interface GwDialogTemplateProps {
  modalTitle?: string
  modalText?: string
}

defineProps<GwDialogTemplateProps>()
</script>

<template>
  <div
    class="f-column w-100"
    style="min-width: clamp(1px, 24rem, 100vw)"
  >
    <GwSurface
      variant="surface_2"
      class="w-100"
      style="padding: var(--app-pad-3) var(--app-pad-3)"
    >
      <slot name="title">
        <GwText variant="text_white_normal-large_500">{{ modalTitle }}</GwText>
      </slot>
    </GwSurface>

    <GwSurface
      variant="surface_1"
      class="w-100 f-center"
      style="padding: var(--app-pad-6) var(--app-pad-4)"
    >
      <slot name="content">
        <GwText
          variant="text_grey_normal-large_500"
          class="text-center"
          v-html="modalText"
        />
      </slot>
    </GwSurface>

    <GwSurface
      variant="surface_2"
      class="f-justify-end w-100"
      style="padding: var(--app-pad-3) var(--app-pad-3)"
    >
      <slot name="actions"> </slot>
    </GwSurface>
  </div>
</template>
